const Status = [
  { label: "已繳清", value: "paid", tagColor: "green" },
  { label: "未繳清", value: "unpaid", tagColor: "red" },
  { label: "未發佈", value: "unpublished", tagColor: null }
];

const Type = [
  { label: "未發佈", value: "unpublished" },
  { label: "未繳清", value: "unpaid" },
  { label: "已繳清", value: "paid" }
];

const PaymentMethod = [
  { label: "現場繳費", value: "cash" },
  { label: "代收專戶", value: "virtual_account" },
  { label: "超商繳費", value: "convenience_store" },
  { label: "社區帳戶", value: "community_bank_account" },
  { label: "其他", value: "other" }
];

export const managementFeeBillCodeList = {
  StatusArray: Status,
  StatusMap: Status.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {}),
  TypeArray: Type,
  TypeMap: Type.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {}),
  PaymentMethodArray: PaymentMethod,
  PaymentMethodMap: PaymentMethod.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {})
};
